import {GetTemplateIdGQL, GetTemplateLegacyIdGQL} from "@app/common/components/viewers/configurator/extensions/bd-cloud/bd-cloud.generated"
import {ExtensionContext} from "@app/common/components/viewers/configurator/extensions/configurator-api-extension"
import {fetchThrowingErrors} from "@app/common/helpers/api/fetch"
import type {CmLogger} from "@cm/log"
import {TemplateReference, TemplateLikeNode} from "@cm/template-nodes"

export async function getTemplateId(template: TemplateLikeNode | undefined, context: ExtensionContext, logger?: CmLogger): Promise<string | undefined> {
    if (template === null) return undefined
    if (template instanceof TemplateReference) {
        const query = context.injector.get(GetTemplateIdGQL)
        const result = await fetchThrowingErrors(query)({templateLegacyId: template.parameters.templateId})
        return result.configuratorData?.id
    }

    logger?.error("Unsupported node type, cannot get template id")

    return undefined
}

export async function getTemplateLegacyId(templateId: string, context: ExtensionContext): Promise<number> {
    const query = context.injector.get(GetTemplateLegacyIdGQL)
    const result = await fetchThrowingErrors(query)({templateId})
    if (!result.configuratorData?.legacyId) throw new Error(`Template ${templateId} not found`)
    return result.configuratorData.legacyId
}
